<template>
  <v-dialog
    v-model="open"
    max-width="60%"
    :persistent="zebraTagLocateState"
  >
    <v-card id="importFile" ref="importFileModal">
      <v-card-title class="headline">
        Търсене на артикул
      </v-card-title>
      <v-card-text class="pt-10">
        <v-row v-if="zebraTagLocateState" class="mb-10">
          <v-col cols="12">
            <v-progress-linear
              v-model="zebraPercentageLocate"
              height="45"
              color="blue lighten-1"
              rounded
              stream
              class="white--text"
            >
              <strong>{{ Math.ceil(zebraPercentageLocate) }}%</strong>
            </v-progress-linear>
          </v-col>
        </v-row>
        <v-row class="mt-5">
          <v-col cols="12">
            <base-material-card 
              icon="mdi-book-open-page-variant"
              color="primary"
            >
              <template v-slot:after-heading>
                <div class="font-weight-light card-title mt-2">
                  Артикул
                </div>
              </template>
              <v-container class="py-7 pt-10">
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      label="Наименование"
                      v-model="data.name"
                      readonly
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="Автор"
                      v-model="data.author"
                      readonly
                    />
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      label="Година на публикуване"
                      v-model="data.publishedYear"
                      readonly
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-text-field
                      label="Инвентарен №"
                      v-model="data.inventoryNumber"
                      readonly
                    />
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      label="Сигнатура"
                      v-model="data.signature"
                      readonly
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-text-field
                      label="Дата"
                      v-model="itemDate"
                      readonly
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-text-field
                      label="Цена"
                      :value="data.price + ' лв.'"
                      readonly
                    />
                  </v-col>
                  <v-col cols="6" class="mx-auto">
                    <v-text-field
                      label="EPC"
                      :value="data.EPC"
                      readonly
                    />
                  </v-col>
                </v-row>
              </v-container>
            </base-material-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn
              :color="zebraTagLocateState ? 'error' : 'success'"
              block
              @click="locateEPC"
            >
              {{ zebraTagLocateState ? 'Прекъсни търсене' : 'Намери артикула'}}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          @click="open = false"
          :disabled="zebraTagLocateState"
        >
          Затвори
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import store from '@/store';
import { mapGetters } from "vuex";
import moment from 'moment';
export default {
  name: 'locateTagModal',
  data(){
    return {
      open: false,
      data: {},
    }
  },
  computed: {
    ...mapGetters([
      'zebraPercentageLocate',
      'zebraTagLocateState'
    ]),
    itemDate() {
      return moment(this.data.date).format("DD.MM.YYYY");
    },
  },
  mounted(){},
  methods: {
    openModal(data){
      this.data = data;
      this.open = true;

      store.dispatch('zebra/getTagLocateStatus');
    },
    closeModal(){
      if(!this.isLocating)
        this.open = false;
    },
    locateEPC(){
      if(!this.zebraTagLocateState){
        store.dispatch('zebra/startTagLocate', this.data.EPC)
      } else {
        store.dispatch('zebra/stopTagLocate', this.data.EPC)
      }
    }
  }
}
</script>